import { createRouter, createWebHashHistory } from 'vue-router';
import ContactDetails from "@/enrol/ContactDetails";
import EmailVerification from "@/enrol/EmailVerification";
import Quiz from "@/enrol/Quiz";
import Results from "@/enrol/Results";
import gtmService from "@/services/GoogleTagService";

let routeGuard = async (to, from, next) => {
  console.log(from, to);
  gtmService.saveAcivity(to.path, 'enrol' + to.path )
  next();
}


const routes = [
  {
    path: '/',
    redirect: '/quiz'
  },
  {
    path: '/quiz/',
    component: Quiz,
    beforeEnter: routeGuard
  },
  {
    path: '/contacts/',
    component: ContactDetails,
    beforeEnter: routeGuard
  },
  {
    path: '/email-verification/',
    component: EmailVerification,
    beforeEnter: routeGuard
  },
  {
    path: '/results/',
    component: Results,
    beforeEnter: routeGuard
  },
]


const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
